import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useBul } from "./BulLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function GoverningBodyPage() {
  const data = useBul();
  const list = data.governing_body || [];
  return (
    <div data-testid="bul-gb-page-wrap">
      <PageHero eyebrow="About" title="Governing Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="cream" testidPrefix="bul-gb-page" />
      </PageBody>
    </div>
  );
}
